import React from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import Button from './Button';

import Dialog, { DialogProps } from './Dialog';
import DialogActions from './DialogActions';
import DialogContent from './DialogContent';
import DialogTitle from './DialogTitle';
import Typography from './Typography';

export interface DialogConfirmProps extends Omit<DialogProps, 'classes' | 'title' | 'content'> {
  title: MessageDescriptor;
  content: MessageDescriptor;
  cancelButton: MessageDescriptor;
  confirmButton: MessageDescriptor;
  handleConfirm: () => void;
  handleCancel: () => void;
  disableConfirmButton?: boolean;
}

const DialogConfirm: React.FC<DialogConfirmProps> = ({
  title,
  content,
  cancelButton,
  confirmButton,
  disableConfirmButton,
  handleConfirm,
  handleCancel,
  ...rest
}) => {
  const { formatMessage } = useIntl();

  return (
    <Dialog {...rest}>
      <DialogTitle>{formatMessage(title)}</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1" paragraph>
          {formatMessage(content)}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button data-lh-id="btn-DialogConfirm-cancel" color="primary" onClick={handleCancel}>
          {formatMessage(cancelButton)}
        </Button>
        <Button
          data-lh-id="btn-DialogConfirm-confirm"
          variant="contained"
          color="error"
          onClick={handleConfirm}
          disabled={!!disableConfirmButton}
        >
          {formatMessage(confirmButton)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirm;
